import React, {Fragment, useEffect, useState} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Input} from 'reactstrap';
import {mapToCssModules} from "reactstrap/lib/utils";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";

import Select from "react-select";
import {selectThemeColors} from "../../../utility/Utils";
import {getCurrentOrganisationName} from "../../../utility/UserUtility";

const MySwal = withReactContent(Swal)

export function arrayToCsv(data) {
    return data.map(row => row
            .map(String)  // convert every value to String
            .map(v => v.replaceAll('"', '""'))  // escape double colons
            .map(v => `"${v}"`)  // quote it
            .join(',')  // comma-separated
    ).join('\r\n');  // rows starting on new lines
}

export function downloadBlob(content, filename, contentType) {
    // Create a blob
    let blob = new Blob([content], {type: contentType});
    let url = URL.createObjectURL(blob);

    // Create a link to download it
    let pom = document.createElement('a');
    pom.href = url;
    pom.setAttribute('download', filename);
    pom.click();
}

const KontaktiModal = (props) => {
    const {
        toggle,
        isOpen,
        constituents
    } = props;

    const [name, setName] = useState("");
    const [validationFailed, setValidationFailed] = useState(false);
    const [competitions, setCompetitions] = useState(false);
    const [chosenCompetitions, setChosenCompetitions] = useState(false);

    useEffect(() => {
        if (!competitions) {
            let url = `${process.env.REACT_APP_MAIN_URL}/admin/competitions`;
            let organisation = getCurrentOrganisationName();
            url += `?org=${organisation}`
            axios.get(url).then((result) => {
                let competitions1 = result.data.competitions.map((oneCompetition) => {
                    return {
                        label: oneCompetition.name + " - " + oneCompetition.sex,
                        value: oneCompetition
                    }
                });
                setCompetitions(competitions1)
            })
        }
    })


    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                Odaberi natjecanja za export
            </ModalHeader>
            <ModalBody>
                <Select
                    theme={selectThemeColors}
                    className='react-select'
                    classNamePrefix='select'
                    value={chosenCompetitions}
                    onChange={(data) => {
                        setChosenCompetitions(data)
                    }}
                    name='clear'
                    options={competitions}
                    isClearable={false}
                />
            </ModalBody>
            <ModalFooter>
                <div className='row justify-content-center text-center' style={{width: "100%"}}>
                    <div className={"col"}>
                        <Button.Ripple onClick={() => {
                            props.toggle();
                        }}
                                       type='submit'
                                       color='danger'
                                       className='btn-next'>
                            <span className='align-middle d-sm-inline-block d-none'>Odustani</span>
                        </Button.Ripple>
                    </div>
                    <div className={"col"}>
                        <Button.Ripple onClick={() => {
                            let allDone = [];
                            let oneCompetition = chosenCompetitions;
                                axios.get(`${process.env.REACT_APP_MAIN_URL}/admin/applications?competitionId=${oneCompetition.value._id}`).then((result) => {
                                    console.log("Res", result)
                                    allDone.push(true);
                                    let myArray = [];
                                    result.data.applications.map((oneApplication) => {
                                        if (!oneApplication.contacts.length) {
                                            myArray.push([oneApplication.constituent.name])
                                        }
                                        oneApplication.contacts.map((oneContact) => {
                                            myArray.push([oneApplication.constituent.name, oneContact.name, oneContact.surname, oneContact.email, oneContact.function, oneContact.mobile]);
                                        })
                                    })
                                    let csv = arrayToCsv(myArray)
                                    downloadBlob(csv, oneCompetition.value.name + '.csv', 'text/csv;charset=utf-8;')
                                })


                        }} type='submit' color='primary' className='btn-next'>
                            <span className='align-middle d-sm-inline-block d-none'>Export kontakata</span>
                        </Button.Ripple>
                    </div>
                </div>
            </ModalFooter>
        </Modal>

    );
}

export default KontaktiModal;